<template>
  <MainSection style="width: 100%; display: flex; flex-direction: column; align-items: center;">
    <!-- Filter by Academic year or Calendar year -->
    <!-- <div class="filter-content">
      <field :label="'Filter by'">
        <multiselect
          :options="[
            { value: 'AcademicYear', name: 'Academic Year' },
            { value: 'CalendarYear', name: 'Calendar Year' },
          ]"
          label="name"
          trackBy="name"
          v-model="filter.filterType"
          mode="single"
          @change="getDataRatio()"
        />
      </field>
    </div> -->

    <div class="new-ratio-container" :class="{'new-ratio-container-wide' : isAsideMobileExpanded}">
      <div class="new-ratio-header-info">
        <p>Cut Off Date: <b>{{ formatDate(cutoffDate) }}</b></p>
      </div>

      <FilterContainer>
        <template #main1>
          <field :label="'Filter by'">
            <control
              v-model="filter.filterType"
              :options="[
                { value: 'Default', name: 'Default' },
                { value: 'AcademicYear', name: 'Academic Year' },
                { value: 'CalendarYear', name: 'Calendar Year' },
              ]"
              @change="getDataRatio()"
            />
          </field>
        </template>
      </FilterContainer>

      <div class="new-ratio-content-outer">
        <div class="new-ratio-content">
          <div class="ratio-content-header">
            <p>Late Payment Ratio</p>
          </div>

          <div class="ratio-content-subheader">
            <p class="subheader-title">Current Month</p>
          </div>

          <div class="ratio-content-table">
            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>Count of Invoice</td>
                    <td>{{ currencyFormatter(currentMonthData.countInvoiceAll) }}</td>
                    <td>Inv.</td>
                  </tr>
                  <tr>
                    <td>Count of Late Payment</td>
                    <td>{{ currencyFormatter(currentMonthData.countInvoiceLate) }}</td>
                    <td>Inv.</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Number of Invoice:</p>
                <p>{{ currentMonthData.lateRatio }} <span>%</span></p>
              </div>
            </div>

            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(currentMonthData.totalInvoiceAll) }}</td>
                  </tr>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(currentMonthData.totalPaymentLate) }}</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Invoice Amount:</p>
                <p>{{ currentMonthData.lateRatioValue }} <span>%</span></p>
              </div>
            </div>
          </div>

          <div class="ratio-content-separator" />

          <div class="ratio-content-subheader">
            <p class="subheader-title">Cummulative</p>

            <div class="filter-selection">
              <FilterContainer>
                <template #main1>
                  <field :label="'Filter Date'">
                    <Datepicker v-model="filter.rangeDate" range />
                  </field>
                </template>
              </FilterContainer>
            </div>
          </div>

          <div class="ratio-content-table">
            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>Count of Invoice</td>
                    <td>{{ currencyFormatter(cumulativeData.countInvoiceAll) }}</td>
                    <td>Inv.</td>
                  </tr>
                  <tr>
                    <td>Count of Late Payment</td>
                    <td>{{ currencyFormatter(cumulativeData.countInvoiceLate) }}</td>
                    <td>Inv.</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Number of Invoice:</p>
                <p>{{ cumulativeData.lateRatio }} <span>%</span></p>
              </div>
            </div>

            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(cumulativeData.totalInvoiceAll) }}</td>
                  </tr>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(cumulativeData.totalPaymentLate) }}</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Invoice Amount:</p>
                <p>{{ cumulativeData.lateRatioValue }} <span>%</span></p>
              </div>
            </div>
          </div>
        </div>

        <div class="new-ratio-content">
          <div class="ratio-content-header">
            <p>Waiver Ratio</p>
          </div>

          <div class="ratio-content-table">
            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>Count all Student</td>
                    <td>{{ currencyFormatter(waiverData.countStudentActive) }}</td>
                    <td>Inv.</td>
                  </tr>
                  <tr>
                    <td>Count Student have Waiver</td>
                    <td>{{ currencyFormatter(waiverData.countWaiverStudent) }}</td>
                    <td>Inv.</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Number of Students</p>
                <p>{{ waiverData.waiverStudentRatio }} <span>%</span></p>
              </div>
            </div>

            <div class="content-ratio">
              <div class="content-ratio-info">
                <table>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(waiverData.totalInvoiceAll) }}</td>
                  </tr>
                  <tr>
                    <td>IDR</td>
                    <td>{{ currencyFormatter(waiverData.totalAllWaiver) }}</td>
                  </tr>
                </table>
              </div>

              <div class="content-ratio-total">
                <p>Ratio Based on<br>Invoice Amount</p>
                <p>{{ waiverData.waiverRatio }} <span>%</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainSection>

  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>
</template>

<script>
  /* eslint-disable */
  import { computed, ref, reactive, onMounted, onBeforeMount, watch } from "vue";
  import axios from "axios";
  import { useStore } from "vuex";
  import Datepicker from "@vuepic/vue-datepicker";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import dayjs from "dayjs"

  import MainSection from "@/components/MainSection";
  import Field from "@/components/Field";
  import Control from "@/components/Control";
  import Multiselect from "@vueform/multiselect";
  import FilterContainer from "@/components/Container/FilterContainer.vue"

  export default {
    components: {
      MainSection,
      Field,
      Control,
      Datepicker,
      Multiselect,
      Loading,
      FilterContainer
    },

    props: {
      cutoffDate: {
        type: Date,
        default: () => "",
      },
    },

    setup(props) {
      const store = useStore()
      const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
      const isLoading = ref(false);
      const filter = reactive({
        cutoff: props.cutoffDate,
        created_by: localStorage.getItem("username"),
        rangeDate: "",
        start_date: "",
        end_date: "",
        filterType: "Default",
      });

      const dataRatio = ref({});
      const currentMonthData = ref({});
      const cumulativeData = ref({});
      const waiverData = ref({});
      const getDataRatio = (evt) => {
        isLoading.value = true;
        filter.cutoff = props.cutoffDate;
        console.log("cek filter", filter)
        axios
        .get("invoice-ratio", { params: filter })
        .then((res) => {
          isLoading.value = false;
          // dataRatio.value = res.data.data;
          currentMonthData.value = res.data.currentMonthData;
          cumulativeData.value = res.data.cumulativeData;
          waiverData.value = res.data.waiverData;
        })
        .catch((error) => {
          isLoading.value = false;

          console.log(error);
        });
      };

      const formatDate = (dateString) => {
        return dayjs(dateString).format("dddd, D MMMM YYYY")
      }

      const currencyFormatter = (currency, sign) => {
        if (typeof currency === "string" && currency.includes(",")) {
          currency = currency.replaceAll(",", "");
        }

        if (currency !== undefined) {
          const sansDec = Number(currency).toFixed();
          const formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          return `${formatted}`;
        }
      };
      // onMounted(() => {
      //   getDataRatio();
      // });

      watch(
        () => [filter.rangeDate],
        ([newVal, newLev]) => {
          if (Array.isArray(newVal) && newVal.length === 2) {
            filter.start_date = newVal[0];
            filter.end_date = newVal[1];
          } else {
            filter.start_date = null;
            filter.end_date = null;
          }
          getDataRatio();
        }
      );

      // watch(
      //   () => [props.cutoffDate],
      //   ([newVal, newLev]) => {
      //     getDataRatio();
      //   }
      // );

      return {
        filter,
        getDataRatio,
        dataRatio,
        isLoading,
        currentMonthData,
        cumulativeData,
        waiverData,
        currencyFormatter,
        formatDate,
        isAsideMobileExpanded
      };
    },
  };
</script>

<style lang="scss">
  .new-ratio-container {
    width: 100%;
    max-width: 800px;
    height: auto;
    // transition: max-width 1s;
    display: flex;
    flex-direction: column;

    .new-ratio-header-info {
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid lightgray;

      p {
        width: 100%;
        text-align: center;
        font-size: 18px;
        line-height: 26px;
        font-weight: 600;
      }
    }

    .new-ratio-content-outer {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 40px 16px;
      margin-top: 20px;

      .new-ratio-content {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        background-color: white;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        padding-bottom: 12px;

        .ratio-content-separator {
          width: calc(100% - 24px);
          height: 2px;
          background-color: lightgray;
          margin: 40px auto 20px auto;
        }

        .ratio-content-header {
          width: 100%;
          min-height: 40px;
          background-image: linear-gradient(to bottom right, #152751, #1a2980);
          display: flex;
          align-items: center;

          p {
            width: 100%;
            min-height: 24px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 700;
            color: white;
            text-align: center;
          }
        }

        .ratio-content-subheader {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          padding: 12px 12px 0 12px;

          p.subheader-title {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-weight: 700;
          }

          .filter-selection {
            width: 100%;
          }

          @media (min-width: 900px) {
            flex-direction: row;
            align-items: center;

            p.subheader-title {
              width: 70%;
              text-align: left;
              padding-left: 12px;
            }

            .filter-selection {
              width: 30%;
              max-width: 300px;
            }
          }
        }

        .ratio-content-table {
          width: 100%;
          height: auto;
          padding: 0 12px;
          display: flex;
          flex-direction: column;
          margin-top: 12px;

          .content-ratio {
            width: 100%;
            background-color: white;
            border: 1px solid lightgray;

            .content-ratio-info {
              width: 100%;
              height: auto;
              padding: 4px 12px;

              table {
                width: 100%;

                tr {
                  td {
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: 600;

                    &:nth-child(2) {
                      font-size: 20px;
                      line-height: 20px;
                      font-weight: 700;
                      text-align: right;
                    }

                    &:nth-child(3) {
                      width: 50px;
                      line-height: 15px;
                      font-weight: 700;
                      vertical-align: bottom;
                      padding-left: 6px;
                    }
                  }
                }
              }
            }

            .content-ratio-total {
              width: 100%;
              display: flex;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: end;
              background-color: #e6eaff;
              padding: 12px;

              p {
                width: auto;
                font-size: 14px;
                line-height: 20px;
                font-weight: 700;

                &:nth-child(2) {
                  width: 150px;
                  font-size: 32px;
                  line-height: 40px;
                  text-align: right;

                  span {
                    font-size: 24px;
                    line-height: 24px;
                  }
                }
              }
            }

            &:nth-child(2) {
              border-top: none;
            }
          }

          @media (min-width: 900px) {
            flex-direction: row;

            .content-ratio {
              width: 55%;

              &:nth-child(2) {
                width: 45%;
                border-top: 1px solid lightgray;
                border-left: none;
              }
            }
          }
        }
      }
    }
  }
  .new-ratio-container-wide {
    @media (min-width: 1280px) {
      max-width: 1400px;

      .new-ratio-content-outer {
        flex-direction: row;

        .new-ratio-content {
          width: calc((100% - 16px) / 2);
        }
      }
    }
  }

  .ratio_container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    // background-color: purple;

    .ratio-general-filter {
      width: 100%;
      height: auto;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 20px;
      // background-color: red;

      @media (min-width: 600px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media (min-width: 1280px) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    .invoice-summary {
      font-size: smaller;
      font-weight: 500;
      margin-left: 10px;
    }

    .invoice-summary i {
      display: block;
      margin-bottom: 1px;
      color: #555; /* opsional */
      text-align:justify;
    }

    .ratio-general-container {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 40px 20px;

      .ratio-main-container {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;

        .ratio-main-outer {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          background-color: white;
          box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

          .ratio-panel-header {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0 12px;
            background-image: linear-gradient(to bottom right, #152751, #1a2980);

            p {
              width: 100%;
              text-align: left;
              font-size: 16px;
              line-height: 16px;
              font-weight: 600;
              color: white;
            }
          }

          .ratio-panel-subheader {
            width: 100%;
            padding: 20px 0 0 0;

            p {
              width: 100%;
              text-align: center;
              font-size: 20px;
              line-height: 28px;
              font-weight: 600;
              color: black;
            }
          }

          .ratio-border-subheader {
            position: relative;
            margin-top: 20px;

            &::before {
              content: "";
              width: calc(100% - 24px);
              height: 1px;
              position: absolute;
              top: 0;
              left: 12px;
              background-color: lightgray;
            }
          }

          .ratio-filter-panel {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            padding: 12px;
          }

          .filter-content {
            padding: 12px 12px 8px 12px;
            margin: 0;
            gap: 12px;
            grid-template-columns: repeat(1, 1fr);

            .general-filter-content {
              p {
                font-size: 12px;
                line-height: 20px;
              }
            }

            @media (min-width: 600px) {
              grid-template-columns: repeat(2, 1fr);
            }

            @media (min-width: 900px) {
              grid-template-columns: repeat(3, 1fr);
            }
          }

          .ratio-panel-outer {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            gap: 20px 12px;
            padding: 12px;

            .ratio-panel-content {
              width: 100%;
              height: auto;
              border: 2px solid lightgray;

              p.ratio-value {
                width: 100%;
                height: auto;
                font-size: 60px;
                line-height: 72px;
                font-weight: 600;
                padding: 12px;
                color: black;
                text-align: right;
              }

              .ratio-desc {
                width: 100%;
                height: calc(48px + 12px + 12px);
                padding: 12px;
                background-color: rgba(0, 0, 0, 0.4);
                backdrop-filter: blur(2px);
                -webkit-backdrop-filter: blur(2px);

                p {
                  font-size: 16px;
                  line-height: 24px;
                  font-weight: 600;
                  color: black;
                }
              }
            }

            .ratio-panel-orange {
              background-image: linear-gradient(
                to bottom right,
                #ffddba,
                #ffe8d1
              );
              border: 2px solid #ffd5aa;

              .ratio-desc {
                background-color: #ffd5aa;
              }
            }

            .ratio-panel-blue {
              background-image: linear-gradient(
                to bottom right,
                #d4f7ff,
                #dff9ff
              );
              border: 2px solid #b6f2ff;

              .ratio-desc {
                background-color: #b6f2ff;
              }
            }
          }
        }
      }

      @media (min-width: 1024px) {
        flex-direction: row;

        .ratio-main-container {
          &:nth-child(1) {
            width: calc(((100% - 20px) / 3) * 2);
            // background-color: green;

            .ratio-main-outer {
              .ratio-panel-outer {
                flex-direction: row;

                .ratio-panel-content {
                  width: calc((100% - 12px) / 2);
                }
              }
            }
          }

          &:nth-child(2) {
            width: calc((100% - 20px) / 3);
            // background-color: red;
          }
        }
      }
    }
  }
</style>
